<script>
	import { Offcanvas, Col, Row } from "sveltestrap";
	import { canvasOpen, isEvLogOpen } from "../../store/store";
	import IoMdInformationCircleOutline from "svelte-icons/io/IoMdInformationCircleOutline.svelte";
	import Modal from "../../views/EvManagement/Manage/ModalEvLogs.svelte"

	export let messages;
	let open;
	canvasOpen.subscribe((val) => {
		open = val;
	});

	const toggle = () => {
		canvasOpen.set(false);
	};

	let modalOpen = false

	function toggleModalUpdate () {
		modalOpen = false
		modalOpen = true
	}
</script>

<div class="offcanvas-container">
	<Offcanvas
		isOpen={open}
		scroll
		backdrop={false}
		placement="top"
		style="background-color:#464646; color:white; height:69px;"
	>
		<Row class="mx-4">
			<Col >
				<Row>
					<Col class="d-flex align-items-center">
						<div class="canvas-icon">
							<IoMdInformationCircleOutline />
						</div>
						<div class="mt-1 ms-3">
							<span>{messages}</span>
						</div>
					</Col>
				</Row>
			</Col>
		
			<Col class="d-flex justify-content-end">
				<button class="text-button pe-4" on:click={toggleModalUpdate}>View recent updates</button>
				<button class="text-button" on:click={toggle}>DISMISS</button>
			</Col>
		</Row>
	</Offcanvas>
</div>

{#if !!modalOpen}
	
<Modal showModal={!!modalOpen}/>
{/if}

<style>
	.canvas-icon {
		width: 24px;
		height: 24px;
	}

	.text-button {
		border: none;
		background-color: transparent;
		color: #c2e9ff;
	}

	.offcanvas-container {
		position: relative;
		/* Other styles to control the size and positioning of the container */
	}
</style>
